<template>
    <DsTable :is-scrollable="true" :is-responsive="true">
        <DsTableRow>
            <DsTableCell type="th">Uhodnutá čísla</DsTableCell>
            <DsTableCell type="th">Počet</DsTableCell>
            <DsTableCell type="th">Výhra</DsTableCell>
            <DsTableCell type="th">Počet výherců</DsTableCell>
        </DsTableRow>
        <DsTableRow>
            <DsTableCell>{{ formatMatchingNumbers(results.matchingNumbers) }}</DsTableCell>
            <DsTableCell>{{ formatCount(results.matchingNumbers?.length) }}</DsTableCell>
            <DsTableCell><span v-html="formatAmount(results.winAmount)"></span></DsTableCell>
            <DsTableCell>{{ formatCount(results.winnersCount) }}</DsTableCell>
        </DsTableRow>
    </DsTable>
</template>

<script lang="ts" setup>
import DsTable from "@sazka/design-system/src/table/ds-table.vue";
import DsTableRow from "@sazka/design-system/src/table-row/ds-table-row.vue";
import DsTableCell from "@sazka/design-system/src/table-cell/ds-table-cell.vue";
import { TicketCheckResultsAddon } from "@/lotteries/model/ticket-check/ticket-check";
import { StringUtils } from "@sazka/utils/string-utils";

defineProps<{
    results: TicketCheckResultsAddon;
}>();

const EMPTY_CELL_STRING = "–––";

const formatAmount = (amount: number) => {
    if (amount) {
        return StringUtils.formatCurrency(amount);
    }

    return EMPTY_CELL_STRING;
};

const formatCount = (count: number) => {
    return count || EMPTY_CELL_STRING;
};

const formatMatchingNumbers = (matchingNumbers: number[]) => {
    return matchingNumbers?.join(", ") || EMPTY_CELL_STRING;
};
</script>
